export default __webpack_public_path__ + "static/media/bestmoneygold.7cc82533.gif";